var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadiusArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3003 13.9914L8.70026 11.3914C8.38359 11.0747 8.31292 10.7124 8.48826 10.3044C8.66292 9.89574 8.97526 9.69141 9.42526 9.69141H14.5753C15.0253 9.69141 15.3376 9.89574 15.5123 10.3044C15.6876 10.7124 15.6169 11.0747 15.3003 11.3914L12.7003 13.9914C12.6003 14.0914 12.4919 14.1664 12.3753 14.2164C12.2586 14.2664 12.1336 14.2914 12.0003 14.2914C11.8669 14.2914 11.7419 14.2664 11.6253 14.2164C11.5086 14.1664 11.4003 14.0914 11.3003 13.9914Z",
    fill: "#008A94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusArrow);
export default __webpack_public_path__ + "static/media/radius-arrow.b6950ddaa768f430573e33464cb350e9.svg";
export { ForwardRef as ReactComponent };